import React from "react";
import { Card, artifactUrl, bboxShort } from "./primitives";

const OUTCOME_CLS = (o) => (o?.startsWith("REGRESSIONE") ? "border-risk-300 bg-risk-50 text-risk-800" : o?.startsWith("VARIAZIONE") ? "border-border bg-muted text-foreground" : "border-warn-300 bg-warn-50 text-warn-800");

const Ev = ({ label, list }) => (
  <div><span className="text-muted-foreground">{label}:</span> {(list || []).length === 0 ? "—" : list.map((e, i) => <span key={i} className="font-mono">{e.evidence_id} p.{e.page} {bboxShort(e.bbox_pct)}{i < list.length - 1 ? "; " : ""}</span>)}</div>
);

/** Variazioni tecniche tra primo run e REV1 su dati NON confrontati in FASE A: valutate contro il PDF originale. */
export const VariationsSection = ({ v }) => {
  const items = v?.items || [];
  return (
    <Card title={`Variazioni tecniche primo run → REV1 su dati non confrontati (${items.length})`} subtitle={v?.method} testId="cl-variations" tone="border-border">
      {v?.coverage_note && <div className="text-[10px] font-bold" data-testid="cl-variations-coverage">{v.coverage_note}</div>}
      {items.map((it) => (
        <details key={it.id} className="border border-border rounded-sm" open data-testid={`cl-variation-${it.id}`}>
          <summary className="px-2 py-1 cursor-pointer text-[11px] bg-muted flex flex-wrap gap-x-3">
            <b>{it.id} · {it.case_id} · {it.field}</b>
            <span className={`px-1.5 border font-bold ${OUTCOME_CLS(it.outcome)}`} data-testid={`cl-variation-outcome-${it.id}`}>{it.outcome}</span>
          </summary>
          <div className="p-2 grid gap-2 lg:grid-cols-[3fr_2fr] text-[10px]">
            <div className="space-y-1">
              <div><span className="text-muted-foreground">Componente / vista:</span> {it.component} — {it.view}</div>
              <div><span className="text-muted-foreground">Valore iniziale (primo run):</span> {it.initial_value}</div>
              <div><span className="text-muted-foreground">Valore REV1:</span> {it.rev1_value}</div>
              <div><span className="text-muted-foreground">Riferimento indipendente:</span> {it.independent_reference}</div>
              <Ev label="Evidenza primo run" list={it.evidence?.first} /><Ev label="Evidenza REV1" list={it.evidence?.rev1} />
              <div><span className="text-muted-foreground">Esito:</span> <b>{it.outcome}</b> — {it.outcome_note}</div>
              <div><span className="text-muted-foreground">Impatto sul preventivo:</span> {it.quote_impact}</div>
            </div>
            <div className="grid gap-1">
              {Object.entries(it.evidence || {}).filter(([k, val]) => k.startsWith("drawing_crop") && typeof val === "string").map(([k, val]) => (
                <figure key={k} className="border border-border rounded-sm p-1 bg-white"><img src={artifactUrl(val)} alt={k} className="w-full" data-testid={`cl-variation-crop-${it.id}-${k}`} /><figcaption className="text-muted-foreground">{val.split("/").pop()}</figcaption></figure>
              ))}
            </div>
          </div>
        </details>
      ))}
    </Card>
  );
};
